import { CREATE_FILTER } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case CREATE_FILTER.LOAD:
      return {
        ...state,
        loading: true,
      };
    case CREATE_FILTER.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case CREATE_FILTER.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
